import _default from './Advertisement';
export { _default as default };